/**
 * AOP 2027 Planning — when a backfill planned here needs a second route (Anna, Oct 2026).
 *
 * An AOP draft reaches the hiring plan only after the AOP is signed off. A backfill that starts in
 * January or February 2027 — or still in 2026 — would wait too long for that, so the form tells the
 * department lead to also propose it on the Org Planning Overview if it needs approval now.
 */
export const EARLY_BACKFILL_BEFORE = '2027-03-01';

export function isEarlyBackfillStart(date: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(date) && date < EARLY_BACKFILL_BEFORE;
}
